module.exports = __webpack_public_path__ + "img/feedback.d314bbb5.svg";